module.exports = __webpack_public_path__ + "static/MissionLabs_Logo_Stacked_Strapline-30ad040219e8599ef68303d67dceb0a0.svg";